import type { Account} from "@/types/v2/account";
import { AccountTypeLabel } from "@/types/v2/account";
import { useDialog } from "@/hooks/v2/use-dialog";
import { Stack, Card, CardHeader, IconButton, Avatar, Divider, Chip } from "@mui/material";
import { PropertyItem } from "@/components/core/v2/property-item";
import { PropertyList } from "@/components/core/v2/property-list";
import { PencilSimple as PencilSimpleIcon , BuildingApartment as BuildingApartmentIcon } from "@phosphor-icons/react";

interface AccountDetailsCardProps {
    account: Account
}

export function AccountDetailsCard({ account }: AccountDetailsCardProps): React.JSX.Element {
 const dialog = useDialog();
    return (
      <Stack spacing={4}>
        <Card>
          <CardHeader
            
            avatar={
              <Avatar>
                <BuildingApartmentIcon fontSize="var(--Icon-fontSize)" />
              </Avatar>
            }
            title="Account Details"
          />
          <PropertyList divider={<Divider />} orientation="vertical" sx={{ '--PropertyItem-padding': '12px 24px' }}>
            {(
              [
                { key: 'Name', value: account.name },
                {
                  key: 'Type',
                  value: AccountTypeLabel[account.type]
                },
                ...(account.email ? [{
                  key: 'Contact',
                  value: <Chip label={account.email} size="small" variant="soft" />
                }] : []),
                ...(account.phone ? [{
                  key: 'Phone',
                  value: <Chip label={account.phone} size="small" variant="soft" />
                }] : []),

              ] satisfies { key: string; value: React.ReactNode }[]
            ).map(
              (item): React.JSX.Element => (
                <PropertyItem key={item.key} name={item.key} value={item.value} />
              )
            )}
          </PropertyList>
        </Card>
      </Stack>)
}
